module.exports = __webpack_public_path__ + "img/andco logo copy.b324df3b.png";